import { useSelector } from 'react-redux';
import { DefaultRootState } from '../persistState';
import { createSelector } from '@reduxjs/toolkit';

export const themeSelector = () => {
	return useSelector((state: DefaultRootState) => state.app.theme.lightTheme);
};

export const selectTheme = createSelector(themeSelector);
